import Component from '../core/Component'

const defaults = {
    destinationUrl: '',
    paramsForBA: '',
    src: '',
}

export default class BookingBAIframe extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            iframe: null,
        }
    }

    prepare() {
        window.BA = window.BA || {}
        window.BA.destinationUrl = this.options.destinationUrl
        window.BA.paramsForBA = this.options.paramsForBA

        const script = document.createElement('script')
        script.src = this.options.src
        script.async = true
        this.element.appendChild(script)
    }
}
